import { createFileRoute } from "@tanstack/react-router";
import { useContext, useEffect } from "react";

const OXLogoMark = "/ox_logomark.png";
import UserContext from "@/contexts/user";

import useApiClient from "@/hooks/useApiClient";

const PROVIDERS = [
  {
    "name": "Azure",
  }
];

const signIn = async ({ api, provider }: { api: any; provider: { name: string } }) => {
  const providerService = api[provider.name.toLowerCase()];
  const { authorization_url: authUrl } =
    await providerService.oauthCookieAuthorize({
      scopes: ["openid", "offline_access"],
    });
  document.location.href = authUrl;
};

export const Route = createFileRoute("/auth/signIn")({
  component: SignInPage,
  staticData: { noLayout: true },
});

function SignInPage() {
  const { setUser } = useContext(UserContext);
  const api = useApiClient();

  useEffect(() => setUser(null), [setUser]);

  return (
    <div className="flex h-max min-h-screen w-screen bg-blue-500">
      <div className="m-auto w-3/4 sm:w-1/4 3xl:w-1/6">
        <div>
          <div className="pb-2 text-center">
            <img alt="OX Logo" src={OXLogoMark} className="mx-auto block" />
          </div>
          <div className="rounded-md bg-zinc-50 py-16 shadow-lg">
            <h1 className="text-center text-5xl text-blue-200">Mako</h1>
            <h3 className="text-2l text-center text-blue-100">
              Mission Data Service
            </h3>
            <div className={"my-auto px-6 pt-36"}>
              {Object.values(PROVIDERS).map((provider) => (
                <div key={provider.name}>
                  <button
                    onClick={async () => signIn({ api, provider })}
                    className="ox-button mx-auto mt-5 w-3/4"
                  >
                    Sign in with {provider.name}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { signIn };
